<template>
  <vue-final-modal v-slot="{ close }" :hide-overlay="true">
    <div class="loginmodal alert-backdrop">
      <div class="art" :class="level" role="dialog" aria-modal="true">
        <span class="status-icon" aria-hidden="true">
          {{ level === 'warningart' ? '!' : type === 'confirm' ? '?' : 'i' }}
        </span>
        <p class="alert-message" v-html="$t(code)"></p>
        <div class="btn">
          <template v-if="type == 'confirm'">
            <button class="yes" @click="$emit('confirm', 'yes', close)">{{$t('front.button.yes')}}</button>
            <button class="no" @click="$emit('confirm', 'no', close)">{{$t('front.button.no')}}</button>
          </template>

          <template v-if="type == 'check'">
            <button class="yes" @click="$emit('check', 'ok', close)">{{$t('front.button.confirm')}}</button>
          </template>
        </div>
        <button class="closeart" type="button" aria-label="close" @click="onClose(close)">×</button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>

import Alert from '@/components/common/Alert'

export default {
  name: 'AlertMobile',
  mixins: [Alert]
}
</script>

<style scoped>
button {font: inherit;cursor: pointer;}
.loginmodal.alert-backdrop {display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:16px;box-sizing:border-box;overflow:hidden;background:rgba(2,6,8,.82);backdrop-filter:blur(7px)}
.art {position:relative;box-sizing:border-box;width:100%;max-width:360px;overflow:hidden;margin:0;padding:34px 20px 22px;text-align:center;border:1px solid rgba(107,228,255,.22);border-radius:17px;box-shadow:0 24px 65px rgba(0,0,0,.52),inset 0 0 24px rgba(107,228,255,.025);background:radial-gradient(circle at 50% 0,rgba(107,228,255,.09),transparent 42%),#0d1519;color:#f4f8f8}
.art::before {content:'';position:absolute;top:0;right:0;left:0;height:2px;background:linear-gradient(90deg,transparent,#6be4ff,#c8ff63,transparent)}
.status-icon {display:flex;align-items:center;justify-content:center;width:38px;height:38px;margin:0 auto 17px;border:1px solid rgba(107,228,255,.44);border-radius:12px;background:rgba(107,228,255,.07);color:#8ceaff;font-size:16px;font-weight:800;line-height:1}
.warningart .status-icon {border-color:rgba(200,255,99,.5);background:rgba(200,255,99,.075);color:#c8ff63}
.art .alert-message {margin:0;color:#e0e9eb;font-size:13px;font-weight:600;line-height:1.65;word-break:keep-all;overflow-wrap:anywhere}
.art .btn {display:flex;justify-content:center;gap:8px;margin-top:24px}
.art .yes,.art .no {box-sizing:border-box;width:100%;height:44px;padding:0 14px;border-radius:9px;font-size:13px;font-weight:850;text-shadow:none}
.art .yes {border:1px solid #c8ff63;background:#c8ff63;color:#091114;box-shadow:0 9px 22px rgba(200,255,99,.12)}
.art .no {border:1px solid rgba(107,228,255,.2);background:rgba(107,228,255,.055);color:#9cabb0}
.closeart {position:absolute;right:9px;top:8px;width:30px;height:30px;padding:0;border:0;border-radius:9px;background:transparent;color:#65757b;font-size:21px;font-weight:300;line-height:28px}

/* electric resort alert */
.loginmodal.alert-backdrop {background:rgba(7,28,58,.48)}
.art {border-color:#cadced;background:linear-gradient(180deg,#fff,#f7faff);color:#17385f;box-shadow:0 24px 62px rgba(6,42,91,.24)}
.art::before {background:linear-gradient(90deg,transparent,#075ee8,#e2b043,transparent)}
.status-icon,.warningart .status-icon {border-color:#9fc2ec;background:#eaf3ff;color:#075ee8}
.art .alert-message {color:#294969}
.art .yes {border-color:#075ee8;background:#075ee8;color:#fff;box-shadow:0 9px 22px rgba(7,94,232,.18)}
.art .no {border-color:#c8daed;background:#eef5fd;color:#58718d}
.closeart {color:#71869e}
</style>
<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
